<template>
  <v-container>
    <v-row align="start">
      <v-col v-if="value.video" cols="12" md="8" lg="6" xl="4">
        <VideoCover
          :aspect-ratio="videoAspectRatio"
          :gradient="COURSE_INTRO_VIDEO_GRADIENT"
          :value="value.video"
          content-class="d-flex align-center justify-center"
          max-height="800"
          style="position: relative"
        >
          <PlayVideo :title="value.video.title" :video="value.video" />

          <div
            v-if="value.badges && value.badges.length"
            class="d-flex pa-4"
            style="position: absolute; bottom: 0; width: 100%"
          >
            <v-img
              v-for="item in value.badges"
              :key="item.id"
              :src="badgeImgSrc(item.image)"
              alt="Badge for course or certification"
              contain
              max-height="80"
              max-width="80"
            />
          </div>
        </VideoCover>
      </v-col>
      <v-col v-else-if="imgResp.src" cols="12" md="8" lg="6" xl="4">
        <v-img
          :aspect-ratio="aspectRatio"
          :sizes="imgResp.sizes"
          :src="imgResp.src"
          :srcset="imgResp.srcset"
          alt="Photo for course introduction"
          cover
          max-height="800"
          style="position: relative"
        >
          <div
            v-if="value.badges && value.badges.length"
            class="d-flex pa-4"
            style="position: absolute; bottom: 0; width: 100%"
          >
            <v-img
              v-for="item in value.badges"
              :key="item.id"
              :src="badgeImgSrc(item.image)"
              alt="Badge for course or certification"
              class="ma-1"
              contain
              max-height="80"
              max-width="80"
            />
          </div>
        </v-img>
      </v-col>

      <v-col cols="12" lg="6" xl="7">
        <TitleParagraphCard
          :fade="isMoreHidden"
          :value="{
            paragraphs: value.paragraphs,
            title: value.title
              ? value.title
              : `About ${course.abbreviated_name || course.name}`
          }"
          @click="toggleMore()"
        >
          <template v-if="scrollToSection" #footer>
            <v-card-item>
              <v-btn
                class="text-none ma-1"
                exact
                rounded="pill"
                size="large"
                @click.stop="toggleMore()"
              >
                {{ isMoreHidden ? 'Read More' : 'Read Less' }}</v-btn
              >

              <v-btn
                class="text-none ma-1"
                exact
                rounded="pill"
                size="large"
                @click.stop="scrollToSection({ key: 'overview' })"
              >
                Overview</v-btn
              >

              <v-btn
                class="text-none ma-1"
                color="primary"
                exact
                rounded="pill"
                size="large"
                @click.stop="scrollToSection({ key: 'register' })"
              >
                Find a Class</v-btn
              >
            </v-card-item>
          </template>
        </TitleParagraphCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { toRef } from 'vue'
import { useToggle } from '@vueuse/core'
import { COURSE_INTRO_VIDEO_GRADIENT } from '#root/lib/consts'
import { createImgSrc, useImgResponsive } from '#root/lib/img'

const props = defineProps({
  course: {
    required: true,
    type: Object
  },
  scrollToSection: {
    default: undefined,
    type: Function
  },
  value: {
    required: true,
    type: Object
  }
})

const [isMoreHidden, toggleMore] = useToggle(true)
const aspectRatio = 8 / 5
const videoAspectRatio = 8 / 5
const badgeImgSrc = createImgSrc()
const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: props.value.image,
    sizes: {
      md: '1600px'
    }
  }))
)
</script>
